import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import RecentMatchedProperties from './components/RecentMatchedProperties';

const recentMatchedProperties = (props,{ t }) => (
  <Container>
    <RecentMatchedProperties {...props} />
  </Container>
);

recentMatchedProperties.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(recentMatchedProperties);
